import Vue from 'vue'
import App from './App.vue'
import VueParticles from 'vue-particles'
import router from './router'
import store from './store'
import api from './http/api'
import md5 from 'js-md5'
import 'element-ui/lib/theme-chalk/index.css'
import VueTinymce from "@packy-tang/vue-tinymce"
import tinymce from 'tinymce'
import '@/assets/iconfont/iconfont.css'
import '@/assets/css/media.scss'
import {
  Input, Button, DatePicker, Dialog, Checkbox, Row, Col, Switch, Cascader, Tabs, Tag, Breadcrumb,
  CheckboxGroup, Radio, RadioGroup, Table, TableColumn, Collapse, CollapseItem, TabPane, BreadcrumbItem,
  Pagination, Card, Form, FormItem, Message, Dropdown, DropdownItem, DropdownMenu, Tooltip, Carousel,
  MessageBox, Select, Option, Loading, Tree, Upload, Menu, Submenu, MenuItemGroup, MenuItem, CarouselItem,
  Alert
} from 'element-ui'
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
// Vue.use(VueQuillEditor);
Vue.use(VueTinymce)
Vue.use(VueParticles)
Vue.component(MessageBox.name, MessageBox)
Vue.use(CarouselItem)
Vue.use(Carousel)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(BreadcrumbItem)
Vue.use(Breadcrumb)
Vue.use(Tag)
Vue.use(TabPane)
Vue.use(Menu)
Vue.use(Cascader)
Vue.use(Switch)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(Button)
Vue.use(Upload)
Vue.use(Loading)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(Alert)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$api = api
Vue.prototype.$md5 = md5
Vue.prototype.$tinymce = tinymce
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
